import { useState, useEffect, useMemo } from 'react';

export function useThreadEntities(events, threadURN) {
  const [remote, setRemote] = useState(null);

  useEffect(() => {
    if (!threadURN) return;
    let cancelled = false;
    fetch(`/api/entities?inThread=${encodeURIComponent(threadURN)}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!cancelled && data) setRemote(data.items ?? data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [threadURN]);

  const local = useMemo(() => deriveLocalEntities(events), [events]);
  return remote ?? local;
}

function deriveLocalEntities(events) {
  const seen = new Map();
  for (const ev of events) {
    const seq = ev?.seq ?? ev?.stream_seq ?? null;
    const refs = [
      ...(ev?.body?.entityRefs || []),
      ...(ev?.body?.sourceRefs || []),
      ...(ev?.refs || []),
    ];
    for (const urn of refs) {
      if (typeof urn !== 'string' || !urn.startsWith('urn:jobe:')) continue;
      if (!seen.has(urn)) {
        const type = urn.split(':')[2] || 'unknown';
        seen.set(urn, { urn, type, firstSeenSeq: seq });
      }
    }
  }
  return [...seen.values()].sort((a, b) => (a.urn < b.urn ? -1 : 1));
}
